/**
 * @generated SignedSource<<00bda745b54feea26e5a791de93e0bb7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_user$data = {
  readonly hasMerchandizingPermission: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDetailTabs_user" | "PdpRespIconBubblesWrapper_user" | "PdpRespMarketplacePersonalizedCarouselLazy_user" | "PdpRespMarketplaceStickyHeader_user" | "PdpRespSharedHeroCarousel_user" | "PdpRespSharedPrintDetailsLazy_user" | "PdpRespSidebarBlurbs_user" | "PdpRespSidebarButtons_user" | "PdpRespSidebarDetails_user" | "PdpRespSidebarSellerInfoAndContactLazy_user" | "PdpRespSimilarItemsLanding_user" | "PdpRespSwatchSelector_user" | "PdpSharedPromoCode_user" | "PdpSharedSellerItemsCarousel_user" | "PdpSharedSidebarFavorites_user" | "PdpSharedVisuallySimilarItemsCarouselLazy_user" | "PdpSharedYMALItemsCarousel_user">;
  readonly " $fragmentType": "PdpRespContainer_user";
};
export type PdpRespContainer_user$key = {
  readonly " $data"?: PdpRespContainer_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespContainer_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchAuction"
    },
    {
      "kind": "RootArgument",
      "name": "isMultiSku"
    },
    {
      "kind": "RootArgument",
      "name": "isPDPDesktopAggregationVariant"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespContainer_user",
  "selections": [
    {
      "alias": "hasMerchandizingPermission",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "BUYER_FE_MERCH_TOOL"
        }
      ],
      "kind": "ScalarField",
      "name": "hasPermission",
      "storageKey": "hasPermission(name:\"BUYER_FE_MERCH_TOOL\")"
    },
    {
      "condition": "isPDPDesktopAggregationVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespMarketplaceStickyHeader_user"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSidebarDetails_user"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedYMALItemsCarousel_user"
    },
    {
      "condition": "fetchAuction",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespMarketplacePersonalizedCarouselLazy_user"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedVisuallySimilarItemsCarouselLazy_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerItemsCarousel_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsLanding_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarButtons_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedHeroCarousel_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubblesWrapper_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarSellerInfoAndContactLazy_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_user"
    },
    {
      "condition": "isMultiSku",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSwatchSelector_user"
        }
      ]
    },
    {
      "condition": "isPDPDesktopAggregationVariant",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespDetailTabs_user"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSharedPrintDetailsLazy_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSidebarFavorites_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "be067fd020c62ebf677d304e2a1cb06f";

export default node;
